/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useState } from 'react'

import 'leaflet/dist/leaflet.css'
import 'leaflet-draw/dist/leaflet.draw.css'

import Menu from '../../components/Menu'

import { useForm } from "react-hook-form"

import { get, post } from '../../services/http'

import { MapContainer, TileLayer, FeatureGroup } from 'react-leaflet'
import { EditControl } from 'react-leaflet-draw'

import { notify } from '../../components/Toast'
import { ToastContainer } from 'react-toastify'

import Table from '../../components/settingList'

export default function index() {
  document.title = 'تنظیمات'
  const [geoData, setGeoData] = useState({})
  const [resturants, setResturants] = useState([])
  const [settings, setSettings] = useState([])
  const [resturantSelect, setResturantSelect] = useState('')
  const [resturantSelectAlert, setResturantSelectAlert] = useState(false)
  const [clickButton, setClickButton] = useState(false)
  const [clickMapButton, setClickMapButton] = useState(false)
  const [resturantSelectMap, setResturantSelectMap] = useState('')
  const [resturantSelectAlertMap, setResturantSelectAlertMap] = useState(false)

  const token = localStorage.getItem('token')

  useEffect(() => {
    get(`/api/admin/shops?token=${token}`)
      .then(response => {
        setResturants(response.data.data.docs)
      }).catch(error => {
        notify('error', 'دریافت اطلاعات با خطا مواجه شد')
      })

    get(`/api/admin/setting?token=${token}`)
      .then(response => {
        setSettings(response.data.data)
      }).catch(error => {
        notify('error', 'دریافت اطلاعات با خطا مواجه شد')
      })
  }, [token])

  const { register, handleSubmit } = useForm()

  const shopHandler = (e) => {
    setResturantSelect(e.target.value)
  }

  const onSubmit = (data, e) => {
    if (resturantSelect.length === 0) {
      setResturantSelectAlert(true)
    } else {
      setResturantSelectAlert(false)
      setClickButton(true)
      post(`/api/admin/setting?token=${token}`, {
          shippingCost: parseInt(data.shippingCost),
          minimumOrder: parseInt(data.minimumOrder),
          mainName: data.mainName,
          branch: resturantSelect
        }).then(response => {
          if (response.data.success) {
            setClickButton(false)
            notify('success', 'تنظیمات با موفقیت آپدیت شد')
            setTimeout(() => {
              window.location.reload()
            }, 2000)
          }
        }).catch(error => {
          notify('error', 'دریافت اطلاعات با خطا مواجه شد')
        })
    }
  }

  const shopHandlerMap = (e) => {
    setResturantSelectMap(e.target.value)
  }

  const geoMapHandler = (e) => {
    e.preventDefault()
    setClickMapButton(true)
    console.log(resturantSelectMap)
    if (geoData.type === undefined) {
      setClickMapButton(false)
      notify('error', 'محدوده را بر روی نقشه مشخص کنید')
    } else if(resturantSelectMap.length === 0) {
      setResturantSelectAlertMap(true)
      setClickMapButton(false)
    } else {
      setResturantSelectAlertMap(false)
      post('/api/admin/geo', {
        geoData: geoData,
        branch: resturantSelectMap
      }).then(response => {
        if (response.data.success) {
          setClickButton(false)
          notify('success', 'نقشه با موفقیت آپدیت شد')
        }
      }).catch(error => {
        notify('error', 'دریافت اطلاعات با خطا مواجه شد')
      })
    }
  }

  return (
    <main id='panel'>
      <ToastContainer rtl />
      <Menu page={''} badgeCountDashboard={0} badgeCountOrder={0} />
      <article className='panelBody'>
        <section className='panelContent'>
          <div className='title'>
            <div className='right'>
              <div className='text'>
                تنظیمات
              </div>
            </div>

            <div className='left'>
            </div>
          </div>

          <form className='form' onSubmit={handleSubmit(onSubmit)}>
            <Table data={settings}/>
            <div className='title'>
              * جهت تغییر تنظیمات می توانید اقدام کنید.
            </div>
            <div className='lineTitle'>
              <hr />
              تنظیمات‌
              <hr />
            </div>
            <div className='row'>
              <div className='column'>
                <label htmlFor='minCartPrice' className='settinInput'>
                  <span>
                    حداقل سفارش از رستوران یا کافی شاپ * :
                  </span>
                  <span>
                  </span>
                </label>
                <input id='minCartPrice' {...register("minimumOrder", { required: true, minLength: 3 })} className='ltrdirection' type='text' placeholder='1200000' />
                <small id='minCartPriceAlert'>حداقل سفارش باید وارد شود</small>
              </div>
              <div className='column'>
                <label htmlFor='foodPrice' className='settinInput'>
                  <span>
                    نام اصلی رستوران یا کافی شاپ * :
                  </span>
                  <span>
                  </span>
                </label>
                <input id='foodPrice' {...register("mainName", { required: true, minLength: 3 })} type='text' placeholder='فست فود ...' />
                <small id='foodPriceAlert'>نام رستوران یا کافی شاپ باید وارد شود</small>
              </div>
            </div>
            <div className="row">
              <div className='column'>
                <label htmlFor='minCartPrice' className='settinInput'>
                  <span>
                    هزینه ارسال (پیک) * :
                  </span>
                  <span>
                  </span>
                </label>
                <input id='minCartPrice' {...register("shippingCost", { required: true, minLength: 0 })} className='ltrdirection' type='text' placeholder='1200000' />
                <small id='minCartPriceAlert'>هزینه ارسال باید وارد شود</small>
              </div>
              <div className='column'>
                <label htmlFor='resturantName'>انتخاب رستوران * :</label>
                <select id='resturantName' {...register("shop", { 
                  onChange: (e) => {shopHandler(e)},
                    required: true })}>
                    <option id='none'>انتخاب کنید</option>
                    {resturants ? resturants.map((item, index) => {
                      return <option key={index} value={item._id}>{item.name}</option>
                    }) : ''}
                </select>
                <small id='resturantNameAlert' style={resturantSelectAlert ? { display : 'flex' } : { display: 'none' }}>رستوران باید انتخاب شود</small>
              </div>
            </div>
            <button className='createButton' style={clickButton ? { backgroundColor: 'gray' } : {}}>ثبت تغییرات</button>
          </form>
          <form action="" className='form'>
            <div className="row">
              <div className='column'>
                <label htmlFor='resturantName'>انتخاب رستوران * :</label>
                <select id='resturantName' {...register("shopMap", { 
                  onChange: (e) => {shopHandlerMap(e)},
                    required: true })}>
                    <option id='none'>انتخاب کنید</option>
                    {resturants ? resturants.map((item, index) => {
                      return <option key={index} value={item._id}>{item.name}</option>
                    }) : ''}
                </select>
                <small id='resturantNameAlert' style={resturantSelectAlertMap ? { display : 'flex' } : { display: 'none' }}>رستوران باید انتخاب شود</small>
              </div>
            </div>
            <div className='map' style={{ margin: '1em 0' }}>
              <MapContainer center={[37.27579, 49.937]} zoom={13} scrollWheelZoom={false}>
                <FeatureGroup>
                  <EditControl 
                    position='topright' 
                    draw={{ rectangle: false, circle: false, circlemarker: false, marker: false, polyline: false }} 
                    onCreated={(e) => {
                      const geoJsonString = e.layer.toGeoJSON()
                      setGeoData(geoJsonString)
                    }}
                    />
                </FeatureGroup>
                <TileLayer
                  attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
              </MapContainer>
            </div>
            <button onClick={geoMapHandler} className='createButton' style={clickMapButton ? { backgroundColor: 'gray' } : {}}>ثبت تغییرات</button>
          </form>
          <div className='copyright'>
            © تمامی حقوق برای <a href='https://ibills.ir'>ibills</a> محفوظ است. طراحی و توسعه توسط <a href='https://ham-team.ir'>هم تیم</a>
          </div>
        </section>
      </article>
    </main>
  )
}
